import axios from "axios";
import { CONFIG } from "../config";


const API_BASE = `${CONFIG.API_URL}/api`;

function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== "") {
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(name + "=")) {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  }

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true, 
  headers: {
    "X-CSRFToken": getCookie("csrftoken"),
  },
});

// Communities
export async function getCommunitiesPaginated() {    
    let allResults = [];
    let url = `/communities/?page_size=100`; 

    while (url) {
      const res = await api.get(url);
      const data = res.data;
      if (Array.isArray(data.results)) {
        allResults = [...allResults, ...data.results];
      }
      url = data.next; 
    }
    return allResults;
  }


export async function createCommunity(data) {
  const formData = new FormData();
  formData.append("name", data.name);
  formData.append("description", data.description);
  if (data.image instanceof File) {
    formData.append("image", data.image);
  }
  const res = await api.post("/communities/", formData);
  return res.data
}


export async function getCommunity(id) {
  const res = await api.get(`/communities/${id}/`);
  return res.data;
}

export async function updateCommunity(id, data) {
  const formData = new FormData();
  formData.append("id", id);
  formData.append("name", data.name);
  formData.append("description", data.description);
  if (data.image instanceof File) {
    formData.append("image", data.image);
  }
  const res = await api.patch(`/communities/${id}/`, formData);
  return res.data;
}

export async function deleteCommunity(id) {
  await api.delete(`/communities/${id}/`);
}

// ---- Topics ----
export async function getTopics(communityId) {
    const res = await api.get(`/communities/${communityId}/topics/`);
    return Array.isArray(res.data) ? res.data : res.data.results;
}

export async function createTopic(communityId, data) {
    const formData = new FormData();
    formData.append("title", data.title);
    formData.append("description", data.description);
    formData.append("community", communityId);
    if (data.image instanceof File) formData.append("image", data.image);
    const res = await api.post(`/communities/${communityId}/topics/`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
}

export async function getTopic(communityId, id) {
    const res = await api.get(`/communities/${communityId}/topics/${id}/`);
    return res.data;
}
  
export async function updateTopic(communityId, id, data) {
  const formData = new FormData();
  formData.append("title", data.title);
  formData.append("description", data.description);
  formData.append("community", communityId);
  formData.append("id", id);
  if (data.image instanceof File) formData.append("image", data.image);
  const res = await api.patch(`/communities/${communityId}/topics/${id}/`, formData);
  return res.data;
}

export async function deleteTopic(communityId, id) {
    const res = await api.delete(`/communities/${communityId}/topics/${id}/`);
    return res.data;
}

// ---- Posts ----
export async function getPosts(communityId, topicId) {
  const res = await api.get(`/communities/${communityId}/topics/${topicId}/posts/`);
  return Array.isArray(res.data) ? res.data : res.data.results;
}

export async function getPostsByTopic(communityId, topicId) {
    const res = await api.get(`/communities/${communityId}/topics/${topicId}/posts/`);
    return Array.isArray(res.data) ? res.data : res.data.results;
  }

  export async function getPost(communityId, topicId, postId) {
    const res = await api.get(`/communities/${communityId}/topics/${topicId}/posts/${postId}/`);
    return res.data;
  }  

export async function createPost(communityId, topicId, data) {
  const formData = new FormData();
  formData.append("content", data.content);
  formData.append("community", communityId);
  formData.append("topic", topicId);
  if (data.image instanceof File) formData.append("image", data.image);
  const res = await api.post(`/communities/${communityId}/topics/${topicId}/posts/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

export async function updatePost(communityId, topicId, postId, data) {
  const formData = new FormData();
  formData.append("content", data.content);
  formData.append("community", communityId);
  formData.append("topic", topicId);
  formData.append("id", postId);
  formData.append("edited", true);
  if (data.image instanceof File) formData.append("image", data.image);
  const res = await api.patch(`/communities/${communityId}/topics/${topicId}/posts/${postId}/`, formData
  );
  
  return res.data;
}

export async function deletePost(communityId, topicId, postId) {
  await api.delete(`/communities/${communityId}/topics/${topicId}/posts/${postId}/`);
}

// ---- Comments ----
export async function getComments(communityId, topicId, postId) {
  const res = await api.get(`/communities/${communityId}/topics/${topicId}/posts/${postId}/comments/`);
  return Array.isArray(res.data) ? res.data : res.data.results;
}

export async function getComment(communityId, topicId, postId, commentId) {
  const res = await api.get(`/communities/${communityId}/topics/${topicId}/posts/${postId}/comments/${commentId}/`);
  return res.data;
}

export async function createComment(communityId, topicId, postId, content, file) {
  const formData = new FormData();
  formData.append("community", communityId);
  formData.append("topic", topicId);
  formData.append("post", postId);
  formData.append("content", content);

  if (file) formData.append("file", file);
  const res = await api.post(`/communities/${communityId}/topics/${topicId}/posts/${postId}/comments/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

export async function updateComment(communityId, topicId, postId, commentId, data) {
  const formData = new FormData();
  formData.append("community", communityId);
  formData.append("topic", topicId);
  formData.append("post", postId);
  formData.append("id", commentId);
  formData.append("content", data.content);
  formData.append("edited", true);
  if (data.file) formData.append("file", data.file);
  const res = await api.patch(`/communities/${communityId}/topics/${topicId}/posts/${postId}/comments/${commentId}/`,formData);
  return res.data;
}

export async function deleteComment(communityId, topicId, postId, commentId) {
  const res = await api.delete(`/communities/${communityId}/topics/${topicId}/posts/${postId}/comments/${commentId}/`,
    { withCredentials: true }
  );
  return res.data;
}


// ---- Mentions ----
export async function getMentions(communityId, topicId, postId) {
  const res = await api.get(`/communities/${communityId}/topics/${topicId}/posts/${postId}/mentions/`);
  return Array.isArray(res.data) ? res.data : res.data.results;
}

export async function createMention(communityId, topicId, postId, mentionId, data) {
  const res = await api.post(`/communities/${communityId}/topics/${topicId}/posts/${postId}/mentions/${mentionId}/`, data);
  return Array.isArray(res.data) ? res.data : res.data.results;
}


export async function toggleLike(communityId, topicId, postId) {
  const res = await api.post(`/communities/${communityId}/topics/${topicId}/posts/${postId}/like/`);
  return res.data;
}